/* *
 * Author:CJW
 * Time:2023.11.14
 * */

export const themes = {
  // 默认主题：切换为默认主题时 使用的变量
  default: {
    baseColour: 'transparent', // 基础色 背景-科技蓝
    baseColourTextColor: `${255},${255},${255}`, // 基础色 文字-白色
    // layoutColour: `${0},${37},${146}`,
    layoutColour: `${255},${255},${255}`,
    logoColour: 'transparent',
    // asideClour: `${0},${15},${58}`,
    asideClour: `${63},${71},${78}`,
    menuTextColorHover: `${52},${58},${64}`,
    menuTextColor: `${255},${255},${255}`,
    homeBoxColor: `${0},${22},${86}`,
    transparentColor: 'transparent',
    tabBoxClour: `${26},${59},${157}`,
    tabContentClour: `${0},${26},${102}`
  },

  // 深色主题：切换为深色主题时 使用的变量
  dark: {
    baseColour: `${33},${37},${41}`, // 基础色 背景-黑
    baseColourTextColor: `${255},${255},${255}`, // 基础色 文字-白色
    layoutColour: `${33},${37},${41}`,
    logoColour: 'transparent',
    asideClour: `${60},${64},${67}`,
    menuTextColorHover: `${52},${58},${64}`,
    menuTextColor: `${255},${255},${255}`,
    homeBoxColor: `${0},${0},${0}`,
    transparentColor: 'transparent',
    tabBoxClour: `${60},${64},${67}`,
    tabContentClour: `${60},${64},${67}`
  },
  light: {
    baseColour: `${255},${255},${255}`, // 基础色 背景-白
    baseColourTextColor: `${95},${95},${95}`, // 基础色 文字-黑色
    layoutColour: `${255},${255},${255}`,
    logoColour: `${95},${95},${95}`,
    asideClour: `${235},${238},${245}`,
    menuTextColorHover: `${52},${58},${64}`,
    menuTextColor: `${95},${95},${95}`,
    homeBoxColor: `${242},${246},${252}`,
    transparentColor: 'transparent',
    tabBoxClour: `${235},${238},${245}`,
    tabContentClour: `${235},${238},${245}`
  }
}
